import _asyncToGenerator from "F:/vue2.0+ vant/2024\u5E74\u9879\u76EE\u96C6\u5408/\u5143\u7FBF\u5B98\u7F51\u9879\u76EE\u96C6\u5408/\u5143\u7FBF\u4E2D\u6587\u7248\u672C/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "regenerator-runtime/runtime.js";
import { ref, onMounted, reactive, onBeforeUnmount, nextTick } from 'vue';
import BannerSwiper from '@/components/BannerSwiper/index.vue';
import { useRouter, useRoute } from "vue-router";
import { getLegalNotice_url } from '@/api'; //引入发送请求获取数据的方法

export default {
  components: {
    BannerSwiper: BannerSwiper
  },
  name: 'legalNotice',
  setup: function setup() {
    var homeBannerList = reactive([{
      id: 0,
      imageUrl: require('@/pages/index/images/newBanner1.png')
    }]);
    var legalNotice = ref({});
    onMounted(function () {
      getLegalNotice();
    });

    var getLegalNotice = /*#__PURE__*/function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var res;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return getLegalNotice_url();

              case 2:
                res = _context.sent;
                // console.log(res,'这是法律信息');
                legalNotice.value = res.data.legalNotice;

              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      return function getLegalNotice() {
        return _ref.apply(this, arguments);
      };
    }();

    return {
      homeBannerList: homeBannerList,
      legalNotice: legalNotice
    };
  }
};